export { graphcacheExchange } from './graphcacheExchange';
